import { render, staticRenderFns } from "./create_template.vue?vue&type=template&id=194855c4&scoped=true"
import script from "./create_template.vue?vue&type=script&lang=js"
export * from "./create_template.vue?vue&type=script&lang=js"
import style0 from "./create_template.vue?vue&type=style&index=0&id=194855c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194855c4",
  null
  
)

export default component.exports